/**
 * Returns the value that comes after the provided value in the array
 * Overflow starts from the beginning
 */
export const getNextArrayValue = <ArrayType>(values: readonly ArrayType[], value: ArrayType) => {
  const toggleIndex = values.indexOf(value);
  const cursor = (toggleIndex + 1) % values.length;
  return values[cursor];
};
